import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { defaultDialogButtons, DialogData } from '../dialog-data.class';
@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.scss'],
  standalone: false
})
/**
 * Component should be called with a button array following the specific structure.
 * The "onClick" return should be the index of the button. All specific logic should be handled by the caller.
 */
export class NotesModalComponent {
  reason: string;
  form: any;
  mandatory = false;
  constructor(
    fb: FormBuilder,
    public dialogRef: MatDialogRef<NotesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    data.buttons = data.buttons ? data.buttons : defaultDialogButtons;
    this.reason = data.reason;
    this.data = data;
    this.form = fb.group({
      reason: [this.reason, [Validators.required, Validators.minLength(1)]],
    });
  }
  /**
   * Returns the index of the pressed button. This should be used by the subscriber function to identify the button
   * Returns the note entered
   * @param buttonIndex the index of the pressed button
   */
  btnCallback(buttonIndex: number): void {
    const { value, valid } = this.form;
    if (!this.data.buttons[buttonIndex].withValidation) {
      this.dialogRef.close({ buttonIndex, value });
    } else if (valid) {
      this.dialogRef.close({ buttonIndex, value });
    } else {
      this.mandatory = true;
    }
  }
}
